/**
 * @module events/types/drop
 */

/**
 * @type {string}
 */
export default 'drop'
